import { getCurrentUserData } from './getCurrentUserData';

const TIER_13_GROUP_ID = 13;
const ONE_DAY_IN_MILLISECONDS = 86400000;

export const getShouldTriggerProjectConfirmationDialog = () => {
  const localStorageData = localStorage.getItem('select-project-timestamp');

  if (localStorageData) {
    const selectProjectTimestamp = JSON.parse(localStorageData ?? '0');
    const currentTimestamp = Date.now();

    const userData = getCurrentUserData();
    const isTier13 = userData?.groupId === TIER_13_GROUP_ID;

    if (isTier13) {
      return false;
    }

    return currentTimestamp - selectProjectTimestamp > ONE_DAY_IN_MILLISECONDS;
  }

  return true;
};
